import { Base } from "../../framework/base";
import { CalendarTaskCategoryListItem, ICalendarTaskCategoryListItem } from "../calendarTaskCategory/calendarTaskCategoryListItem";
import { CalendarTaskEditItem, ICalendarTaskEditItem } from "./calendarTaskEditItem";

export interface ICalendarTaskEdit {
    item: ICalendarTaskEditItem;
    categories: ICalendarTaskCategoryListItem[];
    canSaveCalendarTask: boolean;
    canRemoveCalendarTask: boolean;
    canShareCalendarTasks: boolean;
    userIsIsSystemAdmin: boolean;
}

export class CalendarTaskEdit implements ICalendarTaskEdit {
    item: CalendarTaskEditItem;
    categories: CalendarTaskCategoryListItem[];
    canSaveCalendarTask: boolean;
    canRemoveCalendarTask: boolean;
    canShareCalendarTasks: boolean;
    userIsIsSystemAdmin: boolean;

    constructor();
    constructor(obj: ICalendarTaskEdit);
    constructor(obj?: any) {
        this.item = new CalendarTaskEditItem(obj ? obj.item : null);
        this.categories = Base.getTypedArray(obj ? obj.categories : null, CalendarTaskCategoryListItem);
        this.canSaveCalendarTask = obj && obj.canSaveCalendarTask || false;
        this.canRemoveCalendarTask = obj && obj.canRemoveCalendarTask || false;
        this.canShareCalendarTasks = obj && obj.canShareCalendarTasks || false;
        this.userIsIsSystemAdmin = obj && obj.userIsIsSystemAdmin || false;
    }
}